import Reveal from "../components/Reveal";
import { STATS } from "../data/content";

export default function Numbers() {
  return (
    <section data-testid="numbers-section" className="border-y border-brass/15 bg-forest">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.1}
            className="flex flex-col items-center px-6 py-14 text-center sm:py-20"
          >
            <span
              data-testid={`stat-value-${i}`}
              className="font-serif text-5xl font-light tracking-tight text-ivory sm:text-6xl lg:text-7xl"
            >
              {s.value}
            </span>
            <span className="mt-4 text-[11px] font-medium tracking-[0.35em] text-brass">
              {s.label}
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
